var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { filterMenuItems } from "@apptypes/filterMenuItems";
import { useBEOController } from "@context/BeoContext";
import { useEffect, useState } from "react";
/**
 * Custom hook to filter and load menu items based on the user's roles and permissions
 * obtained from the BEO context.
 *
 * The filtering logic is performed by the external function `filterMenuItems`.
 *
 * @author rajeev.k
 * @param {import("primereact/menuitem").MenuItem[] | import("primereact/menuitem").MenuItem[][]} items
 * The initial array of MenuItem objects (or a 2D array if grouped) to be filtered.
 * @returns {import("primereact/menuitem").MenuItem[]} An array of filtered MenuItem objects
 * that the current user is allowed to see, based on their 'view' or 'create' permissions.
 */
export var useMenuItemsLoader = function (items) {
    var _a = useState([]), menuItems = _a[0], setMenuItems = _a[1];
    var context = useBEOController()[0];
    useEffect(function () {
        var fetchMenu = function () { return __awaiter(void 0, void 0, void 0, function () {
            var roles, allowedRoutes;
            var _a;
            return __generator(this, function (_b) {
                roles = (_a = context === null || context === void 0 ? void 0 : context.userInfo) === null || _a === void 0 ? void 0 : _a.roles;
                allowedRoutes = roles === null || roles === void 0 ? void 0 : roles.filter(function (role) { return (role === null || role === void 0 ? void 0 : role.permission) === "view" || (role === null || role === void 0 ? void 0 : role.permission) === "create"; }).map(function (role) { return role === null || role === void 0 ? void 0 : role.pathname; });
                try {
                    setMenuItems(filterMenuItems(items, allowedRoutes));
                }
                catch (err) {
                    console.error("Error fetching menu:", err);
                }
                return [2 /*return*/];
            });
        }); };
        fetchMenu();
    }, [context === null || context === void 0 ? void 0 : context.userInfo]);
    return menuItems;
};
